import { TypeI18nSkeleton } from '@/@types/generated/contentful';
import ContentfulService from './base/ContentfulService';

export default class I18nService extends ContentfulService {
	public async getI18n(): Promise<Record<string, Record<string, string>>> {
		const i18nDictionary: Record<string, Record<string, string>> = {};
		// Load i18n entries
		const i18nCollection = await this.deliveryClient.withAllLocales.getEntries<TypeI18nSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'i18n',
			limit: 1000,
		});

		i18nCollection.items.forEach((i18nEntry): void => {
			Object.keys(i18nEntry.fields.value).forEach((localeId: string): void => {
				if (!i18nEntry.fields.key.de) {
					return;
				}

				i18nDictionary[localeId] = i18nDictionary[localeId] || {};
				i18nDictionary[localeId][i18nEntry.fields.key.de] = i18nEntry.fields.value[localeId] as string;
			});
		});


		return i18nDictionary;
	}
}

